export default __webpack_public_path__ + "static/woman-5f14c81a41dfa88845c81bd11dbf7aff.png";